<div class="modal-header">
    <!-- <h4 class="modal-title">Hi there!</h4> -->
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row mt-3 label-fontsize">
        <div class="col-12 mb-3 width-400">
            <label>Number of Multi Price</label>
            <select class="form-control text-fontsize">
                <!-- <option *ngFor="let variant of gameVariants" [value]="variant.id">
                    {{ variant.name }}
                </option> -->
            </select>
        </div>

        <h4 class="ms-4">Ticket Prices</h4>
        <div class="col-12 mb-3 width-400">
            <input type="text" class="form-control">
        </div>
        <div class="col-12 mb-3 width-400">
            <input type="text" class="form-control">
        </div>
        <div class="col-12 mb-3 width-400">
            <input type="text" class="form-control">
        </div>
        <div class="col-12 mb-3 width-400">
            <input type="text" class="form-control">
        </div>
        <div class="col-12 mb-3 width-400">
            <input type="text" class="form-control">
        </div>
    </div>
    <div class="col-12 form-check form-check-inline mb-2">
        <input class="form-check-input" type="checkbox" id="prices">
        <label class="form-check-label label-fontsize" for="prices">Ticket Prices</label>
    </div>

    <div class="row">
        <div class="col-5 mb-3 width-400">
            <input type="text" class="form-control">
        </div>
        <div class="col-2 px-0">
            (And, OR)
        </div>
        <div class="col-5 mb-3 width-400">
            <input type="text" class="form-control">
        </div>
    </div>
    <div class="col-12 form-check form-check-inline mb-2">
        <input class="form-check-input" type="checkbox" id="prices">
        <label class="form-check-label label-fontsize" for="prices">Super Books</label>
    </div>
    <div class="row">
        <div class="col-3 mb-3 width-400">
            <select class="form-control text-fontsize">
                <option></option>
            </select>
        </div>
        <div class="col-4 mb-3 width-400">
            <input type="text" class="form-control">
        </div>
        <div class="col-5 mb-3 width-400">
            <input type="text" class="form-control">
        </div>
    </div>
</div>
<div class="modal-footer">
    <!-- <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button> -->
</div>